import React, { Component } from 'react';
import { CorrectTick } from '../../../assets/images';
import Skeleton from 'react-loading-skeleton';

class PreferredPartner extends Component {
  getPartnerName() {
    const { list } = this.props;
    const length = list.length;
    return list.map((listItem, index) => (
      <div
        key={listItem.partner_name}
        className={
          `flex m-2 justify-between ` + (index === length - 1 ? 'mb-0' : '') + (index === 0 ? (this.props.header ? 'mt-4' : 'mt-0') : 'mt-3')
        }
      >
        <div className='flex items-center'>
          <img src={CorrectTick} className='mr-3 ' width='17' height='17' alt='greentick' />
          <div className='text-gray-700 font-semibold'>{listItem.partner_name}</div>
        </div>
      </div>
    ));
  }

  getEmployeeCount() {
    const { list } = this.props;
    const length = list.length;
    return list.map((listItem, index) => (
      <div
        key={`${listItem}`+ index}        
        className={`flex m-2 justify-between ` + (index === length - 1 ? 'mb-0' : '') + (index === 0 ? (this.props.header ? 'mt-4' : 'mt-0') : 'mt-3')}
      >
        <div className='text-gray-700'>
          <b className='text-gray-700 font-semibold'>{listItem.employee_count}</b>
          &nbsp;users
        </div>
      </div>
    ));
  }

  render() {
    if (this.props.loading) {
      return <Skeleton width='100%' height={this.props.loaderHeight} />;
    }

    return (
      <div className={this.props.classes}>
        {this.props.header && <hr className='relative top-14 border-t border-gray-200 mx-7' />}
        <div
          className={`flex bg-white justify-between p-5 border border-gray-250 overflow-hidden rounded-ds-md w-full ` + this.props.classes}
        >
          <div className='flex flex-col'>
            {this.props.header && <div className='text-ts-md text-gray-500 font-semibold ml-2 mb-5 leading-none'>{this.props.header}</div>}
            {this.getPartnerName()}
          </div>
          <div className='flex flex-col'>
            {this.props.header && <div className='text-ts-md text-gray-500 font-semibold ml-2 mb-5 leading-none'>Preferred by</div>}
            {this.getEmployeeCount()}
          </div>
        </div>
      </div>
    );
  }
}

PreferredPartner.defaultProps = {
  classes: '',
};

export default PreferredPartner;
